import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { staticPageService } from '@/app/[locale]/_service/page.service'
import { getMultiLangText } from '@/app/[locale]/_utils/getMultiLangText'
import { useCustomLocale } from './useCustomLocale'
import { useDynamicLanguage } from './useShipper'
import { useSelector } from 'react-redux'
import type { IRedux } from '../_store/types'

export function useStaticPageLabels() {
  const locale = useCustomLocale()
  const { useDynamicLanguage: dynamic } = useDynamicLanguage()
  const shipper_id = useSelector((state: IRedux) => state.settings?.data?.shipper_id)

  const { data } = useQuery({
    queryKey: ['static-pages-list', locale, dynamic, shipper_id],
    queryFn: () =>
      staticPageService
        .getAll(shipper_id, dynamic)
        .then((res) => res?.data?.static_pages ?? []),
    staleTime: 5 * 60 * 1000,
  })

  const labelsBySlug = useMemo(() => {
    const map: Record<string, string> = {}

    data?.forEach((page) => {
      if (!page?.slug) return
      map[page.slug] = getMultiLangText(page.name, locale)
    })

    return map
  }, [data, locale])

  return { labelsBySlug }
}
